<ion-header class="extendido">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>{{'Resumo da Reunião' | translate}}</ion-title>
  </ion-buttons>
</ion-header>

<ion-content>
  <div class="gradient-extendido"></div>

  <div>
    <form
      class="sample-form validations-form"
      [formGroup]="validations_form"
      (ngSubmit)="onSubmit(validations_form.value)"
    >
      <ion-grid>
        <ion-row>
          <ion-col>
            <ion-item lines="none">
              <ion-select
                label="{{'Status' | translate}}"
                labelPlacement="floating"
                interface="action-sheet"
                cancelText="{{ 'Cancelar' | translate}}"
                okText="{{ 'Confirmar' | translate}}"
                formControlName="status"
              >
                <ion-select-option [value]="0"
                  >{{'Agendado' | translate}}</ion-select-option
                >
                <ion-select-option [value]="1"
                  >{{'Realizado' | translate}}</ion-select-option
                >
                <ion-select-option [value]="2"
                  >{{'Cancelado' | translate}}</ion-select-option
                >
              </ion-select>
            </ion-item>
          </ion-col>
        </ion-row>

        <ion-item-divider></ion-item-divider>

        <ion-row>
          <ion-col>
            <ion-item lines="none">
              <ion-textarea
                label="{{'Resumo' | translate}}"
                labelPlacement="floating"
                placeholder="{{'Resumo' | translate}}"
                rows="3"
                formControlName="resumo"
              ></ion-textarea>
            </ion-item>
          </ion-col>
        </ion-row>

        <ion-item-divider *ngIf="reuniao.numero_presentes"></ion-item-divider>

        <ion-row *ngIf="reuniao.numero_presentes">
          <ion-col>
            <p class="total">
              {{'Total de Participantes: ' | translate}} {{
              reuniao.numero_presentes }}
            </p>
          </ion-col>
        </ion-row>

        <ion-item-divider></ion-item-divider>

        <ion-row *ngIf="!userProvider.hasConfig(194)">
          <ion-col>
            <ion-item lines="none">
              <ion-input
                label="{{'Nº de Crianças Presentes' | translate}}"
                labelPlacement="floating"
                placeholder="{{'Nº de Crianças Presentes' | translate}}"
                formControlName="numCriancas"
                type="number"
              >
              </ion-input>
            </ion-item>
          </ion-col>
        </ion-row>

        <ion-item-divider></ion-item-divider>

        <ion-row *ngIf="!userProvider.hasConfig(195)">
          <ion-col>
            <ion-item lines="none">
              <ion-input
                label="{{'Nº de Visitantes Presentes' | translate}}"
                labelPlacement="floating"
                placeholder="{{'Nº de Visitantes Presentes' | translate}}"
                formControlName="numVisitantes"
                type="number"
              >
              </ion-input>
            </ion-item>
          </ion-col>
        </ion-row>

        <ion-item-divider
          *ngIf="!userProvider.hasConfig(196)"
        ></ion-item-divider>

        <ion-row *ngIf="!userProvider.hasConfig(196)">
          <ion-col>
            <ion-item lines="none">
              <ion-input
                label="{{'Alimentos Doados (Kg)' | translate}}"
                placeholder="{{'Alimentos Doados (Kg)' | translate}}"
                labelPlacement="floating"
                formControlName="quilos_doados"
                type="number"
              >
              </ion-input>
            </ion-item>
          </ion-col>
        </ion-row>

        <ion-item-divider
          *ngIf="!userProvider.hasConfig(197)"
        ></ion-item-divider>

        <ion-row *ngIf="!userProvider.hasConfig(197)">
          <ion-col>
            <ion-item lines="none">
              <ion-toggle
                justify="space-between"
                formControlName="supervisao"
                [enableOnOffLabels]="true"
                (ionChange)="isSupervisao($event)"
                class="config bold-1"
                >{{'Houve Supervisão ?' | translate}}</ion-toggle
              >
            </ion-item>
          </ion-col>
        </ion-row>

        <ion-item-divider
          *ngIf="supervisao && !userProvider.hasConfig(197)"
        ></ion-item-divider>

        <ion-row *ngIf="supervisao && !userProvider.hasConfig(197)">
          <ion-col>
            <ion-item lines="none">
              <ion-input
                label="{{'Nome do Supervisor(es)' | translate}}"
                labelPlacement="floating"
                formControlName="supervisaoNome"
                placeholder="{{'Nome do Supervisor(es)' | translate}}"
                type="text"
              >
              </ion-input>
            </ion-item>
          </ion-col>
        </ion-row>

        <ion-item-divider
          *ngIf="!userProvider.hasConfig(198)"
        ></ion-item-divider>

        <ion-row *ngIf="!userProvider.hasConfig(198)">
          <ion-col>
            <ion-item lines="none">
              <ion-toggle
                justify="space-between"
                formControlName="idPossuiCusto"
                [enableOnOffLabels]="true"
                (ionChange)="oferta($event)"
                class="config bold-1"
                >{{'Houve ' | translate}}{{'oferta' | nomenclatura |
                async}}?</ion-toggle
              >
            </ion-item>
          </ion-col>
        </ion-row>

        <ion-item-divider
          *ngIf="possuiCusto && !userProvider.hasConfig(198)"
        ></ion-item-divider>

        <ion-row *ngIf="possuiCusto && !userProvider.hasConfig(198)">
          <ion-col>
            <ion-item lines="none">
              <ion-input
                label="{{'Valor ' | translate}}{{'oferta' | nomenclatura | async}}"
                labelPlacement="floating"
                formControlName="valorOferta"
                placeholder="{{'R$ 00,00' | translate}}"
                type="decimal"
                (ionInput)="formatValor($event)"
              >
              </ion-input>
            </ion-item>
          </ion-col>
        </ion-row>

        <ion-item-divider></ion-item-divider>

        <div class="down" *ngIf="!readOnly">
          <ion-button
            class="btn-success"
            expand="block"
            type="submit"
            [disabled]="!validations_form.valid"
          >
            {{'Salvar' | translate}}
          </ion-button>
        </div>
      </ion-grid>
    </form>
  </div>
</ion-content>
